import React, { useState } from "react";
import { X } from "lucide-react";
import API from "../../api";

const RenewProjectModal = ({ isOpen, onClose, projectId, onRenewed }) => {
  const [years, setYears] = useState(1);
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleRenew = async () => {
    if (!projectId) return;
    if (!window.confirm(`Renew this domain for ${years} year(s)?`)) return;

    try {
      setLoading(true);
      await API.put(`/admin/projects/renew/${projectId}`, { years });
      alert("✅ Domain renewed successfully");
      onRenewed();
      onClose();
    } catch (err) {
      console.error(err);
      alert("❌ Failed to renew domain");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white w-80 rounded-lg shadow-lg p-6 relative">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
        >
          <X size={20} />
        </button>

        <h2 className="text-lg font-semibold text-gray-800 mb-4">Renew Project</h2>

        <label className="block mb-2 text-sm font-medium text-gray-700">
          Select Number of Years
        </label>
        <select
          value={years}
          onChange={(e) => setYears(Number(e.target.value))}
          className="w-full border rounded-lg px-3 py-2 mb-4 focus:ring focus:ring-blue-200"
        >
          <option value={1}>1 Year</option>
          <option value={2}>2 Years</option>
          <option value={3}>3 Years</option>
          <option value={4}>4 Years</option>
          <option value={5}>5 Years</option>
        </select>

        <button
          onClick={handleRenew}
          disabled={loading}
          className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition disabled:opacity-50"
        >
          {loading ? "Renewing..." : `Renew for ${years} Year${years > 1 ? "s" : ""}`}
        </button>
      </div>
    </div>
  );
};

export default RenewProjectModal;
